import keymirror from 'keymirror';

export const onboardingEvents = keymirror({
  FIRST_CLICK: null,
  PAGE_EXIT: null,
  QUICKSTART_FRAMEWORK_SELECT: null
});
